import type { IngestStatus } from "@contract-manager/shared";

/**
 * When the screen has to keep looking.
 *
 * Extraction runs off an S3 event, so a row is `UPLOADED` the moment it is
 * created and only becomes `EXTRACTED` some seconds later. Without polling the
 * list a staffer just uploaded to sits there looking broken until they reload.
 */

/**
 * Five seconds. Extraction takes tens of seconds, so anything much shorter
 * only adds requests; anything much longer and the page feels stuck.
 */
export const POLL_INTERVAL_MS = 5000;

const SETTLED: ReadonlySet<IngestStatus> = new Set<IngestStatus>([
  "EXTRACTED",
  "APPROVED",
  "FAILED",
]);

/** Whether this record has reached a state nothing will move it out of. */
export function isSettled(status: IngestStatus): boolean {
  return SETTLED.has(status);
}

/**
 * Whether anything on screen is still moving.
 *
 * Only the rows actually loaded are considered. A record still extracting on
 * page four is not a reason to keep polling page one, and the next page load
 * picks it up anyway.
 */
export function hasPendingWork(
  // Only the status matters, and a redacted contract still carries it.
  records: readonly { readonly ingestStatus: IngestStatus }[],
): boolean {
  return records.some((record) => !isSettled(record.ingestStatus));
}
